import { render, staticRenderFns } from "./supplier-in-data-list.vue?vue&type=template&id=68369306&"
import script from "./supplier-in-data-list.vue?vue&type=script&lang=js&"
export * from "./supplier-in-data-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports